import React from "react";

// "Ready for download | 23/10/2026 21:10 | XLSX". React.Children.toArray keys the parts, which
// keep their position: the list never reorders them.
export const renderJoined = (parts: React.ReactNode[]) =>
  React.Children.toArray(
    parts.flatMap((part, index) => (index > 0 ? [" | ", part] : [part])),
  );
